import { render } from "./PaasPage.vue?vue&type=template&id=335d5e75&scoped=true"
import script from "./PaasPage.vue?vue&type=script&lang=js"
export * from "./PaasPage.vue?vue&type=script&lang=js"

import "./PaasPage.vue?vue&type=style&index=0&id=335d5e75&scoped=true&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-335d5e75"]])

export default __exports__